// libs
import React, { useCallback, useState } from 'react';

// types
import { TFunction } from '@lyearn/i18n';
import { ExerciseAttach, Plus } from '@lyearn/icons';
import { cn } from '@lyearn/style';
// components
import { Input, Stack, Typography } from '@lyearn/ui';
import { RenderInputParams } from '@lyearn/ui';
// styles
import getAutoWidthInputStyles from '@/helper/getAutoWidthInputStyles';
import { AutocompleteRenderOptionState } from '@/modules/corporate/modules/database/fields/components/DatabaseSelect/components/OptionItem/types';

import { renderInputStyles } from './styles';
import { IOption } from './types';

interface RenderOptionParams {
  t: TFunction;
  option: IOption;
  state: AutocompleteRenderOptionState;
}

export const renderOption = ({ option, state, t }: RenderOptionParams) => {
  if (option.type === 'create') {
    return (
      <Stack alignItems="center" className="max-w-full" gapX={4}>
        <Plus className="h-16 w-16 flex-shrink-0 fill-current text-text-placeholder" />
        <Typography color="text-text-placeholder" variant="body-short-01">
          {t('Course:Builder.CreateQuiz')}
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack alignItems="center" className="max-w-full" gapX={8}>
      <Typography
        className="truncate"
        color={state.selected ? 'text-text-primary' : 'text-text-secondary'}
        variant="body-short-01">
        {option.name}
      </Typography>
      <Typography className="flex-shrink-0" color="text-text-placeholder" variant="body-short-03">
        {t('Course:Builder.questions', { count: option.questionsCount })}
      </Typography>
    </Stack>
  );
};

interface InputRendererParams {
  onBlurPlaceholder: string;
  onFocusPlaceholder: string;
  params: RenderInputParams;
}

export const RenderInput = ({
  params,
  onBlurPlaceholder,
  onFocusPlaceholder,
}: InputRendererParams) => {
  const [placeholder, setPlaceholder] = useState<string>(onBlurPlaceholder);

  const onBlur = useCallback(() => {
    setPlaceholder(onBlurPlaceholder);
  }, [onBlurPlaceholder]);

  const onFocus = useCallback(() => {
    setPlaceholder(onFocusPlaceholder);
  }, [onFocusPlaceholder]);

  return (
    <Input
      {...params}
      autoFocus
      className={cn(
        'rounded-4 bg-s-info-light focus-within:bg-bg-primary',
        getAutoWidthInputStyles(onBlurPlaceholder.length * 2.3),
        renderInputStyles,
      )}
      placeholder={placeholder}
      startAdornment={<ExerciseAttach className="fill-current text-icon-secondary" />}
      variant="body-long-01"
      onBlur={onBlur}
      onFocus={onFocus}
    />
  );
};
